module.exports = __webpack_public_path__ + "static/media/SnowstormEffect.d.ts.66f951b7.map";